import { api } from "./api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const b64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(b64);
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
}

export async function ensurePushSubscribed() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return { ok: false, reason: "unsupported" };
  const perm = Notification.permission === "default" ? await Notification.requestPermission() : Notification.permission;
  if (perm !== "granted") return { ok: false, reason: "denied" };

  const reg = await navigator.serviceWorker.register("/sw.js");
  const { data } = await api.get("/push/vapid-public");
  const key = urlB64ToUint8Array(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  }
  const raw = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: raw.endpoint, keys: raw.keys, on_call: true });
  return { ok: true, endpoint: raw.endpoint };
}

export async function unsubscribePush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const raw = sub.toJSON();
    try {
      await api.post("/push/unsubscribe", { endpoint: raw.endpoint, keys: raw.keys || {} });
    } catch (err) {
      console.warn("[push] unsubscribe backend call failed (safe to ignore):", err?.message || err);
    }
    await sub.unsubscribe();
  }
}

export async function pushStatus() {
  if (!("serviceWorker" in navigator)) return { supported: false };
  if (!("PushManager" in window)) return { supported: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, permission: Notification.permission, subscribed: !!sub };
}
